import React from "react";
import { Box, Button, Heading, Flex } from "@chakra-ui/react";
import { Formik, Form } from "formik";
import CustomField from "../Common/Form/CustomField";

const ProductsFilter = ({ getPriceLists }) => {
  const handleSubmit = (values) => {
    let queries = {};
    if (values.name) {
      queries.text = values.name;
    }
    getPriceLists(queries);
  };

  return (
    <>
      <Heading variant="h2">Filtros</Heading>

      <Box>
        <Formik
          initialValues={{ name: "" }}
          onSubmit={(values, actions) => {
            handleSubmit(values);
            actions.setSubmitting(false);
          }}
        >
          {(props) => (
            <Form>
              <Flex
                spacing="50px"
                align="left"
                flexDirection={["column", "row"]}
                justifyContent="space-around"
              >
                <Box w={["auto", "45%"]}>
                  <CustomField
                    name="name"
                    title="Buscador"
                    placeholder="Ingrese un nombre"
                    props={props}
                    customFontColor="menu.700"
                  ></CustomField>
                </Box>

                <Box align="right">
                  <Button
                    mt={4}
                    colorScheme="teal"
                    isLoading={props.isSubmitting}
                    type="submit"
                  >
                    Buscar
                  </Button>
                </Box>
              </Flex>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default ProductsFilter;
